(() => {
  'use strict';

  const CARD_SELECTOR = '.product-card-wrapper';
  const MEDIA_SELECTOR = '.card__media .media--hover-effect';
  const ACTIVE_CLASS = 'st-secondary-active';
  const AUTO_CLASS = 'st-auto-preview';

  const touchDevice = window.matchMedia(
    '(hover: none) and (pointer: coarse)'
  );

  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  let previewObserver = null;

  function getMedia(card) {
    return card.querySelector(MEDIA_SELECTOR);
  }

  function hasSecondImage(card) {
    const media = getMedia(card);

    return (
      media &&
      media.querySelectorAll(':scope > img').length >= 2
    );
  }

  function closeOtherCards(currentCard) {
    document
      .querySelectorAll(`${CARD_SELECTOR}.${ACTIVE_CLASS}`)
      .forEach((card) => {
        if (card !== currentCard) {
          card.classList.remove(ACTIVE_CLASS);
        }
      });
  }

  function createPreviewObserver() {
    if (previewObserver) return previewObserver;

    previewObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (
            !entry.isIntersecting ||
            entry.intersectionRatio < 0.65
          ) {
            return;
          }

          const card = entry.target;

          previewObserver.unobserve(card);

          if (card.dataset.stPreviewed === 'true') return;

          card.dataset.stPreviewed = 'true';

          window.setTimeout(() => {
            if (!card.isConnected) return;

            if (card.classList.contains(ACTIVE_CLASS)) return;

            card.classList.add(AUTO_CLASS);

            window.setTimeout(() => {
              card.classList.remove(AUTO_CLASS);
            }, 1500);
          }, 1800);
        });
      },
      {
        threshold: [0.65]
      }
    );

    return previewObserver;
  }

  function setupAutomaticPreview(root = document) {
  if (reduceMotion.matches) return;

  const observer = createPreviewObserver();
  const cards = [];

  // If the added element itself is a product card
  if (
    root instanceof Element &&
    root.matches(CARD_SELECTOR)
  ) {
    cards.push(root);
  }

  // Product cards contained inside the added element
  if (root.querySelectorAll) {
    cards.push(
      ...root.querySelectorAll(CARD_SELECTOR)
    );
  }

  cards.forEach((card) => {
    if (!hasSecondImage(card)) return;

    if (card.dataset.stPreviewObserved === 'true') return;

    card.dataset.stPreviewObserved = 'true';
    observer.observe(card);
  });
}

  function handleProductTap(event) {
    const card = event.target.closest(CARD_SELECTOR);

    if (!card || !hasSecondImage(card)) return;

    const media = getMedia(card);

    if (!media || !media.contains(event.target)) return;

    /*
      Remove the hand instruction as soon as the
      first New Arrivals image is touched.
    */
    const hint = card.querySelector('[data-st-view-back-cue]');

    if (hint) {
      hint.remove();
    }

    if (!touchDevice.matches) return;

    /*
      First tap: show image 2.
      Second tap: allow the product page to open.
    */
    if (!card.classList.contains(ACTIVE_CLASS)) {
      event.preventDefault();
      event.stopPropagation();

      closeOtherCards(card);

      card.classList.remove(AUTO_CLASS);
      card.classList.add(ACTIVE_CLASS);
    }
  }

  function closeCardsWhenTappingOutside(event) {
    if (!touchDevice.matches) return;

    if (!event.target.closest(CARD_SELECTOR)) {
      document
        .querySelectorAll(
          `${CARD_SELECTOR}.${ACTIVE_CLASS}`
        )
        .forEach((card) => {
          card.classList.remove(ACTIVE_CLASS);
        });
    }
  }

  function initialise(root = document) {
    setupAutomaticPreview(root);
  }

  document.addEventListener(
    'click',
    handleProductTap,
    true
  );

  document.addEventListener(
    'click',
    closeCardsWhenTappingOutside
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initialise()
    );
  } else {
    initialise();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialise(event.target);
    }
  );
/* ===== S THEORY: mount hint on first card in New Arrivals ===== */
function mountViewBackHint() {
  const featuredSection = document.querySelector('.featured-collection');
  if (!featuredSection) return;

  const heading = featuredSection.querySelector('.title, .inline-richtext, h2');
  if (!heading) return;

  const headingText = heading.textContent.trim().toLowerCase();
  if (!headingText.includes('new arrivals')) return;

  const firstCard = featuredSection.querySelector('.product-card-wrapper, .grid__item .card-wrapper');
  if (!firstCard) return;

  const hint = firstCard.querySelector('[data-st-view-back-hint]');
  if (!hint) return;

  if (hint.dataset.mounted === 'true') return;
  hint.dataset.mounted = 'true';

  const media = firstCard.querySelector('.card__media, .media');
  if (!media) return;

  const showHint = () => {
    hint.classList.add('is-visible');

    setTimeout(() => {
      hint.classList.remove('is-visible');
    }, 4500);
  };

  const hideHint = () => {
    hint.classList.remove('is-visible');
  };

  const observer = new IntersectionObserver((entries) => {
    const entry = entries[0];
    if (entry.isIntersecting && entry.intersectionRatio > 0.35) {
      setTimeout(showHint, 500);
      observer.disconnect();
    }
  }, {
    threshold: [0.35]
  });

  observer.observe(firstCard);

  media.addEventListener('click', hideHint, { once: true });
  media.addEventListener('touchstart', hideHint, { once: true });
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    mountViewBackHint();
  }, 700);
});

document.addEventListener('shopify:section:load', () => {
  setTimeout(() => {
    mountViewBackHint();
  }, 700);
});
function watchInfiniteScrollProducts() {
  const productGrid = document.querySelector('#product-grid');

  if (!productGrid) return;

  // Prevent creating the watcher twice
  if (productGrid.dataset.stPreviewWatcher === 'true') return;

  productGrid.dataset.stPreviewWatcher = 'true';

  const gridObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        // Give Shopify a moment to finish inserting the card
        window.setTimeout(() => {
          setupAutomaticPreview(node);
        }, 100);
      });
    });
  });

  gridObserver.observe(productGrid, {
    childList: true
  });
}
document.addEventListener('DOMContentLoaded', () => {
  watchInfiniteScrollProducts();
});

document.addEventListener('shopify:section:load', () => {
  window.setTimeout(() => {
    watchInfiniteScrollProducts();
  }, 200);
});
})();